import { wmsPlusHttp, otmsHttp } from '@/utils/http/index';

/**
 * @description: 数据字典接口
 * @api: https://yapi.ops.yunlizhi.cn/project/388/interface/api/11212
 */
export function getDictionaryFromWms() {
  return wmsPlusHttp.get('/warehouse_foundation/dictionary/get_dictionary_json');
}

export function getDictionaryFromWms1() {
  return wmsPlusHttp.get('/warehouse_foundation/dictionary/get_dictionary_json');
}

/**
 * 获取系统列表
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/18949
 * @param {object} data request body
 */
export function fetchSystemList(data) {
  return otmsHttp.request({
    url: '/permission-plus/system/list',
    method: 'post',
    data,
  });
}

/**
 * 获取租户的权限清单树(区分systemCode)
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/18943
 * @param {object} data request body
 */
export function fetchTenantAuthorityTree(data) {
  return otmsHttp.request({
    url: '/permission-plus/tenant/role/function/tree',
    method: 'post',
    data,
  });
}

/**
 * 将权限与租户关联 / 解绑(老数据没有systemCode)
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/18945
 * @param {object} data request body
 */
export function upsertTenantAuthority(data) {
  return otmsHttp.request({
    url: '/permission-plus/tenant/role/function/ref/upsert',
    method: 'post',
    data,
  });
}
/**
 * 通过菜单反向关联租户
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/24119
 * @param {object} data request body
 */
export function upsertTenantExpansionMenuRelation(data) {
  return otmsHttp.request({
    url: '/permission-plus/tenant/expansion/menu/relation',
    method: 'post',
    data,
  });
}
/**
 * 通过菜单id选中租户
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/24253
 * @param {object} data request body
 */
export function findAllTenantExpansion(data, params) {
  return otmsHttp.request({
    url: '/permission-plus/tenant/expansion/tenant/find/all',
    method: 'post',
    data,
    params,
  });
}
/**
 * 分页显示通过菜单id选中租户
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/24255
 * @param {object} data request body
 */
export function queryTenantExpansion(data, params) {
  return otmsHttp.request({
    url: '/permission-plus/tenant/expansion/tenant/query',
    method: 'post',
    data,
    params,
  });
}
/**
 * 取消权限
 * https://yapi.ops.yunlizhi.cn/project/337/interface/api/24257
 * @param {object} data request body
 */
export function cancelTenantExpansionMenu(data) {
  return otmsHttp.request({
    url: '/permission-plus/tenant/expansion/menu/cancel',
    method: 'post',
    data,
  });
}

// 数据字典
export function getOptionsFromDictionary(data) {
  return otmsHttp.request({ url: '/base_plus/data_dictionary/list', method: 'post', data });
}
